import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { UserService } from 'src/services/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    providers: [DialogService]
})
export class UsersComponent implements OnInit {
    // private state variables
    users: any = []
    loading: boolean = false;
    isVisibleAddUserDialog = false;
    clonedUsers: { [s: string]: any; } = {};   
    userForm: FormGroup = new FormGroup({
        userName: new FormControl(''),
        userEmailId: new FormControl(''),
        userIsAdmin: new FormControl(false),
        userIsActive: new FormControl(false)
    });
    
    isAdminDropdown = [{label: 'Yes', code: true}, {label: 'No', code: false}]
    isActiveDropdown = [{label: 'Active', code: true}, {label: 'Inactive', code: false}]
    
    constructor(private breadcrumbService: AppBreadcrumbService, public dialogService: DialogService, private _userService: UserService, private messageService: MessageService) {
        this.breadcrumbService.setItems([
            { label: 'Users', routerLink: ['/users'] }
        ]);
    }

    ngOnInit(): void {
        this.getAllUsers();
    }

    toggleAddUserDialog() {
        this.isVisibleAddUserDialog = !this.isVisibleAddUserDialog;
    }

    async getAllUsers() {
        this.loading = true;
        this._userService.getAllUsers().subscribe((res) => {
            this.users = res;
            this.loading = false;
        }, (error) => {
            this.loading = false;
            this.messageService.add({ 
                key: 'uc', 
                severity: 'error', 
                summary: 'Error', 
                detail: 'Failed to load users!' 
            });
        })
    }

    async addUser(userData: any) {
        let user = {
            "userID": 0,
            "name": userData.userName,
            "eMailId": userData.userEmailId,
            "isAdmin": userData.userIsAdmin?.code == undefined ? false : userData.userIsAdmin?.code,
            "isActive": true
        }
        
        if (this.userForm.valid) {
            // Check for duplicate email
            if (this.isDuplicateEmail(user.eMailId)) {
                this.messageService.add({
                    key: 'uc', 
                    severity: 'warn', 
                    summary: 'Duplicate Email', 
                    detail: 'A user with this email already exists!'
                });
                return;
            }

            this._userService.createOrUpdateUser(user).subscribe((res) => {
                this.getAllUsers();
                this.messageService.add({ key: 'uc', severity: 'success', summary: 'Success', detail: 'User Added!' });
                this.isVisibleAddUserDialog = false;
                this.userForm.reset()
            })
        }
        else {
            this.messageService.add({key: 'uc', severity:'error', summary: 'Invalid Input', detail: 'Check Fields before Submitting!'});
        }
    }

    onRowEditInit(user: any) {
        this.clonedUsers[user.userID] = {...user};
    }

    onRowEditSave(userData: any) {
        delete this.clonedUsers[userData.userID];
        let user = {
            "userID": userData.userID,
            "name": userData.name,
            "eMailId": userData.eMailId,
            "isAdmin": userData.isAdmin.code == undefined ? userData.isAdmin : userData.isAdmin.code,
            "isActive": userData.isActive.code == undefined ? userData.isActive : userData.isActive.code
        }
        
        if (user.userID != '' && user.name != '' && user.eMailId != '') {          
            this._userService.createOrUpdateUser(user).subscribe((res) => {
                this.getAllUsers();
                this.messageService.add({ 
                    key: 'uc', 
                    severity: 'success', 
                    summary: 'Success', 
                    detail: 'User Update Successful!' 
                });
                delete this.clonedUsers[user.userID];
            }, (error) => {
                this.messageService.add({
                    key: 'uc', 
                    severity:'error', 
                    summary: 'Error', 
                    detail: 'Failed to update user!'
                });
            })
        }
        else {
            this.messageService.add({
                key: 'uc', 
                severity:'error', 
                summary: 'Invalid Input', 
                detail: 'Check Fields before Submitting!'
            });
        }
    }

    onRowEditCancel(user: any, index: number) {
        this.users[index] = this.clonedUsers[user.userID];
        delete this.clonedUsers[user.userID];
    }

    clear(table: Table) {
        table.clear();
    }

    isDuplicateEmail(email: string): boolean {
        if (!email) return false;
        return this.users.some((user: any) => 
            user.eMailId.toLowerCase() === email.toLowerCase()
        );
    }
}
